/* ============================================================
   KUGO theme JS
   - menu overlay
   - AJAX cart drawer ("BAG")
   - variant / size picker
   - quick add
   - accordions
   - reveal-on-scroll
   ============================================================ */
(function () {
  'use strict';

  var moneyFormat = window.KUGO && window.KUGO.moneyFormat ? window.KUGO.moneyFormat : '₹{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    return moneyFormat
      .replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount)
      .replace(/<[^>]+>/g, '');
  }

  /* ---------------- Menu overlay ---------------- */
  // A page may carry more than one burger — the product page puts one on
  // the image so it scrolls with the photo — so bind every instance and
  // keep their aria state in sync.
  var burgers = document.querySelectorAll('[data-k-burger]');
  var menu = document.querySelector('[data-k-menu]');

  function setBurgersExpanded(open) {
    Array.prototype.forEach.call(burgers, function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    document.body.classList.remove('k-menu-open');
    setBurgersExpanded(false);
    document.body.style.overflow = '';
  }

  /* The game popup opens FROM the menu and has to shut it properly — not just
     hide the panel, but reset the burger back from its ✕ and release the
     scroll lock the menu took. Exposed so it can't drift from this one. */
  window.KUGO = window.KUGO || {};
  window.KUGO.closeMenu = closeMenu;

  if (burgers.length && menu) {
    Array.prototype.forEach.call(burgers, function (burger) {
      burger.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        document.body.classList.toggle('k-menu-open', open);
        setBurgersExpanded(open);
        document.body.style.overflow = open ? 'hidden' : '';
      });
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
    menu.addEventListener('click', function (e) {
      if (!e.target.closest('.k-menu__panel')) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ---------------- Contact popup ---------------- */
  // Lives in the header, so it is reachable from the menu's CONTACT US and
  // from CONNECT in the product page's + links.
  var contactModal = document.querySelector('[data-k-contact]');
  if (contactModal) {
    var closeContact = function () {
      contactModal.hidden = true;
      document.body.style.overflow = '';
    };
    var openContact = function () {
      closeMenu();
      contactModal.hidden = false;
      document.body.style.overflow = 'hidden';
      var first = contactModal.querySelector('.k-contact__field');
      if (first) first.focus();
    };

    // Any link explicitly marked, or pointing at the contact page, opens
    // the popup instead of navigating. Delegated so it covers menu links,
    // product quick links and anything added later.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link || contactModal.contains(link)) return;
      var href = link.getAttribute('href') || '';
      if (link.hasAttribute('data-k-contact-open') || /\/pages\/contact(\/|\?|#|$)/.test(href)) {
        e.preventDefault();
        openContact();
      }
    });

    contactModal.querySelectorAll('[data-k-contact-close]').forEach(function (el) {
      el.addEventListener('click', closeContact);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !contactModal.hidden) closeContact();
    });

    // Shopify redirects back here after a successful send
    if (window.location.search.indexOf('contact_posted=true') !== -1) openContact();
  }

  /* ---------------- Mobile hero drawer (SHOP ALL rail) ---------------- */
  var mhero = document.querySelector('[data-k-mhero]');
  if (mhero) {
    var mopen = mhero.querySelector('[data-k-mopen]');
    var mclose = mhero.querySelector('[data-k-mclose]');
    if (mopen) {
      mopen.addEventListener('click', function () {
        mhero.classList.add('is-open');
        mopen.setAttribute('aria-expanded', 'true');
      });
    }
    if (mclose) {
      mclose.addEventListener('click', function () {
        mhero.classList.remove('is-open');
        if (mopen) mopen.setAttribute('aria-expanded', 'false');
      });
    }
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = document.querySelector('[data-k-cart-drawer]');
  var itemsEl = drawer ? drawer.querySelector('[data-k-cart-items]') : null;
  var totalEl = drawer ? drawer.querySelector('[data-k-cart-total]') : null;
  var footEl = drawer ? drawer.querySelector('[data-k-cart-foot]') : null;
  var recsEl = drawer ? drawer.querySelector('[data-k-recs]') : null;
  var recsList = drawer ? drawer.querySelector('[data-k-recs-list]') : null;

  function setBagCount(n) {
    document.querySelectorAll('[data-k-bag-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.add('is-bumped');
      setTimeout(function () { el.classList.remove('is-bumped'); }, 300);
    });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* The reference cart prices read "2999/-" rather than the site's rupee format. */
  function money2(cents) { return Math.round(cents / 100) + '/-'; }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function thumbOf(url) { return url ? url.replace(/(\.[a-z]{3,4})(\?|$)/, '_240x$1$2') : ''; }

  /* Quantity tiers: the fill runs to the top tier, and each node/label lights
     up once its threshold is met. */
  function updateTiers(qty) {
    if (!drawer) return;
    var t1 = parseInt(drawer.getAttribute('data-tier1'), 10) || 1;
    var t2 = parseInt(drawer.getAttribute('data-tier2'), 10) || 2;
    var t3 = parseInt(drawer.getAttribute('data-tier3'), 10) || 3;
    /* Nodes are placed at qty/t3 along the track, so a plain proportional
       fill always stops exactly on the node it just unlocked. */
    var fill = drawer.querySelector('[data-k-tier-fill]');
    if (fill) fill.style.width = Math.max(0, Math.min(100, (qty / t3) * 100)) + '%';
    [[1, t1], [2, t2], [3, t3]].forEach(function (pair) {
      var hit = qty >= pair[1];
      var node = drawer.querySelector('[data-k-tier-node="' + pair[0] + '"]');
      var lab = drawer.querySelector('[data-k-tier-label="' + pair[0] + '"]');
      if (node) node.classList.toggle('is-hit', hit);
      if (lab) lab.classList.toggle('is-hit', hit);
    });
  }

  function renderCart(cart) {
    setBagCount(cart.item_count);
    updateTiers(cart.item_count);
    if (!itemsEl) return;

    if (!cart.items.length) {
      var emptyMsg = drawer && drawer.dataset.emptyLabel ? drawer.dataset.emptyLabel : 'Your bag is empty.';
      var shopLabel = drawer && drawer.dataset.shopLabel ? drawer.dataset.shopLabel : 'Shop all';
      var shopUrl = drawer && drawer.dataset.shopUrl ? drawer.dataset.shopUrl : '/collections/all';
      itemsEl.innerHTML =
        '<div class="k-cart2__empty">' +
          '<p>' + esc(emptyMsg) + '</p>' +
          '<a href="' + esc(shopUrl) + '" class="k-btn k-btn--ghost">' + esc(shopLabel) + '</a>' +
        '</div>';
      if (footEl) footEl.hidden = true;
      if (recsEl) recsEl.hidden = true;
      return;
    }

    if (footEl) footEl.hidden = false;
    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = thumbOf(item.image);
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="k-cart2__variant">' + esc(item.variant_title) + '</div>' : '';
      return (
        '<div class="k-cart2__row" data-line-key="' + esc(item.key) + '">' +
          '<div class="k-cart2__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="k-cart2__info">' +
            '<div class="k-cart2__nameline">' +
              '<div>' +
                '<div class="k-cart2__name">' + esc(item.product_title) + '</div>' +
                variant +
                '<div class="k-cart2__price">' + money2(item.final_line_price) + '</div>' +
              '</div>' +
              '<button type="button" class="k-cart2__remove" data-k-remove aria-label="Remove">&times;</button>' +
            '</div>' +
            '<div class="k-cart2__qty">' +
              '<button type="button" data-k-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-k-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    if (totalEl) totalEl.textContent = money2(cart.total_price);
    loadRecs(cart);
  }

  /* ---- BUILD YOUR LOOK -------------------------------------------------
     Shopify's recommendation endpoint returns full variant data, so each
     suggestion gets its own size picker. ADD TO CART stays disabled until a
     size is chosen, so nothing can be added in a size the shopper did not
     pick. Results are cached per product and re-filtered against the cart, so
     anything already in the bag drops out without another request. */
  var recCache = {};
  var recProductCache = {};

  /* Colourway siblings for a suggestion, when it has any. Each colour is its
     own product (see kugo-colour-swatches), so these swap the row's product
     in place rather than switching a variant — the shopper never leaves the
     cart to change colour. */
  function recColours(handle) {
    var groups = (window.KUGO && window.KUGO.colourGroups) || {};
    var set = groups[handle];
    if (!set || set.length < 2) return '';
    return '<div class="k-cart2__reccolours">' + set.map(function (c) {
      return '<button type="button" class="k-cart2__reccolour' +
             (c.s ? ' k-cart2__reccolour--art' : '') +
             (c.h === handle ? ' is-on' : '') + '"' +
             ' data-k-reccolour="' + esc(c.h) + '"' +
             ' title="' + esc(c.t) + '" aria-label="' + esc(c.t) + '"' +
             (c.h === handle ? ' aria-current="true"' : '') + '>' +
             (c.s ? '<img src="' + esc(c.s) + '" alt="" width="22" height="22" loading="lazy">' : '') +
             '<span class="visually-hidden">' + esc(c.n || c.t) + '</span>' +
             '</button>';
    }).join('') + '</div>';
  }

  function recMarkup(p) {
    var img = thumbOf(p.featured_image || (p.images && p.images[0]) || '');
    var vs = p.variants || [];
    var single = vs.length === 1 && /default/i.test(vs[0].title || '');
    var sizes = single ? '' :
      '<div class="k-cart2__recsizes">' + vs.map(function (v) {
        return '<button type="button" class="k-cart2__size" data-k-recsize="' + v.id + '"' +
               (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
      }).join('') + '</div>';
    var initial = single ? vs[0].id : '';
    var url = p.url || ('/products/' + p.handle);
    return (
      '<div class="k-cart2__rec" data-k-rec data-handle="' + esc(p.handle || '') + '"' +
           ' data-variant="' + initial + '">' +
        '<a class="k-cart2__thumb" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="k-cart2__info">' +
          '<a class="k-cart2__name k-cart2__reclink" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
          '<div class="k-cart2__price">' + money2(p.price) + '</div>' +
          recColours(p.handle) +
          sizes +
          '<button type="button" class="k-cart2__add" data-k-rec-add' + (initial ? '' : ' disabled') + '>ADD TO CART</button>' +
        '</div>' +
      '</div>'
    );
  }
  function loadRecs(cart) {
    if (!recsEl || !recsList || !cart.items.length) return;
    var pid = cart.items[0].product_id;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = 1; });

    var hidden = (window.KUGO && window.KUGO.hiddenProducts) || [];
    function paint(list) {
      var out = (list || []).filter(function (p) {
        return !inCart[p.id] && hidden.indexOf(p.handle) === -1;
      }).slice(0, 3);
      if (!out.length) { recsEl.hidden = true; return; }
      recsList.innerHTML = out.map(recMarkup).join('');
      recsEl.hidden = false;
    }
    if (recCache[pid]) { paint(recCache[pid]); return; }
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=related',
          { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { recCache[pid] = d.products || []; paint(recCache[pid]); })
      .catch(function () { recsEl.hidden = true; });
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        try { renderCart(cart); } catch (err) { /* keep the drawer usable */ }
        return cart;
      })
      .catch(function () { return null; });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return fetchCart().then(openDrawer);
    });
  }

  /* Colourway swatches on a shop feed card. The card is itself an <a>, so the
     swatches are spans rather than nested anchors — navigate them by hand and
     cancel the card's own click so it doesn't win the race. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-k-swatch]');
    if (!sw) return;
    var href = sw.getAttribute('data-k-swatch');
    if (!href) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = href;
  });

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-k-cart-open]');
    // Open the drawer IMMEDIATELY, then load its contents — so a cart-fetch or
    // render hiccup can never leave the BAG unable to open.
    if (openBtn) { e.preventDefault(); openDrawer(); fetchCart(); return; }

    var closeBtn = e.target.closest('[data-k-cart-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-k-qty]');
    if (qtyBtn) {
      var row = qtyBtn.closest('[data-line-key]');
      var qty = parseInt(row.querySelector('.k-cart2__qty span').textContent, 10) + parseInt(qtyBtn.dataset.kQty, 10);
      changeLine(row.dataset.lineKey, Math.max(0, qty));
      return;
    }

    var removeBtn = e.target.closest('[data-k-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.closest('[data-line-key]').dataset.lineKey, 0);
      return;
    }

    /* BUILD YOUR LOOK — pick a colour, which swaps the row's product in
       place (new photo, price, sizes and link) without leaving the cart. */
    var colBtn = e.target.closest('[data-k-reccolour]');
    if (colBtn) {
      e.preventDefault();
      var colRow = colBtn.closest('[data-k-rec]');
      var want = colBtn.getAttribute('data-k-reccolour');
      if (!colRow || !want || want === colRow.getAttribute('data-handle')) return;
      var swap = function (prod) {
        if (!prod) return;
        colRow.outerHTML = recMarkup(prod);
      };
      if (recProductCache[want]) { swap(recProductCache[want]); return; }
      colBtn.classList.add('is-loading');
      fetch('/products/' + encodeURIComponent(want) + '.js',
            { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (prod) { recProductCache[want] = prod; swap(prod); }
          else { colBtn.classList.remove('is-loading'); }
        })
        .catch(function () { colBtn.classList.remove('is-loading'); });
      return;
    }

    /* BUILD YOUR LOOK — pick a size, which unlocks that row's ADD TO CART */
    var sizeBtn = e.target.closest('[data-k-recsize]');
    if (sizeBtn) {
      e.preventDefault();
      var recRow = sizeBtn.closest('[data-k-rec]');
      if (!recRow) return;
      recRow.querySelectorAll('[data-k-recsize]').forEach(function (b) { b.classList.remove('is-on'); });
      sizeBtn.classList.add('is-on');
      recRow.setAttribute('data-variant', sizeBtn.getAttribute('data-k-recsize'));
      var addBtn = recRow.querySelector('[data-k-rec-add]');
      if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'ADD TO CART'; }
      return;
    }

    var recAdd = e.target.closest('[data-k-rec-add]');
    if (recAdd) {
      e.preventDefault();
      var row2 = recAdd.closest('[data-k-rec]');
      var vid = row2 && row2.getAttribute('data-variant');
      if (!vid) return;
      recAdd.disabled = true;
      recAdd.textContent = '...';
      addToCart(vid, 1)
        .catch(function () { recAdd.disabled = false; recAdd.textContent = 'SOLD OUT'; });
      return;
    }

    var quick = e.target.closest('[data-k-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.textContent = '...';
      addToCart(quick.dataset.kQuickAdd, 1)
        .then(function () { quick.textContent = 'Added'; setTimeout(function () { quick.textContent = 'Add to bag'; }, 1600); })
        .catch(function () { quick.textContent = 'Sold out'; });
    }
  });

  if (drawer) {
    drawer.querySelector('.k-cart-drawer__scrim').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------------- Product form / size picker ---------------- */
  document.querySelectorAll('[data-k-product]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-k-variants]').textContent);
    var sizeBtns = root.querySelectorAll('[data-k-size]');   // single-option: one button per variant
    var optBtns = root.querySelectorAll('[data-k-opt]');     // multi-option: one row per option
    var addBtn = root.querySelector('[data-k-add]');
    var stockEl = root.querySelector('[data-k-stock]');
    var priceEls = document.querySelectorAll('[data-k-price]');
    var selected = null;

    /* ---- Low stock callout ---------------------------------------------
       Says how many are left of the SELECTED size, points at that size, then
       takes itself away. On first load it waits until the buy row is on
       screen, so the one time it fires is a time someone can see it. */
    var lowEl = root.querySelector('[data-k-lowstock]');
    var lowBubble = lowEl && lowEl.querySelector('[data-k-lowstock-text]');
    var lowRow = root.querySelector('.k-pdp__buyrow') || root;
    var lowShowT = null, lowHideT = null, lowPrimed = false;

    function hideLowStock() {
      if (!lowEl) return;
      clearTimeout(lowShowT); clearTimeout(lowHideT);
      lowEl.classList.remove('is-on');
      lowHideT = setTimeout(function () { lowEl.hidden = true; }, 200);
    }

    /* Centre on the size button, but keep the bubble inside the row. When it
       has to be clamped, the arrow shifts back the other way so it still
       points at the size rather than drifting off it. */
    function placeLowStock(btn) {
      var host = lowEl.offsetParent;
      if (!host || !btn) return false;
      var hb = host.getBoundingClientRect(), bb = btn.getBoundingClientRect();
      if (!bb.width || !hb.width) return false;
      var want = bb.left - hb.left + bb.width / 2;
      var half = lowBubble.offsetWidth / 2, pad = 6;
      var lo = half + pad, hi = hb.width - half - pad;
      var x = hi < lo ? hb.width / 2 : Math.max(lo, Math.min(want, hi));

      /* Below the size by default. Where the CTA is stacked under the sizes
         (mobile, and the two-option set) hanging below would cover ADD TO
         CART, so turn the callout over and point down instead. */
      var bubbleH = lowBubble.offsetHeight;
      var above = false;
      var atc = root.querySelector('[data-k-add]');
      if (atc) {
        var ab = atc.getBoundingClientRect();
        if (ab.top >= bb.bottom - 1 && bb.bottom + bubbleH + 7 > ab.top) above = true;
      }
      /* Flipped, it is tucked closer: the space above the sizes is shared with
         the colourway swatches, so every pixel back is one less covered. */
      var gap = above ? 4 : 7;
      lowEl.classList.toggle('is-above', above);
      lowEl.style.left = x + 'px';
      lowEl.style.top = (above
        ? bb.top - hb.top - bubbleH - gap
        : bb.bottom - hb.top) + 'px';
      lowEl.style.setProperty('--k-arrow-dx', (want - x) + 'px');
      return true;
    }

    function showLowStock(v, btn, tries) {
      if (!lowEl || !lowBubble) return;
      var limit = parseInt(lowEl.dataset.threshold, 10) || 5;
      var qty = v && v.inventory_quantity;
      if (!v || !v.available || !(qty > 0 && qty < limit)) { hideLowStock(); return; }
      clearTimeout(lowShowT); clearTimeout(lowHideT);
      lowBubble.textContent = qty + ' ' + (lowEl.dataset.label || 'LEFT');
      lowEl.hidden = false;
      lowEl.classList.remove('is-on');
      /* Measure and place while it is laid out but still transparent. If the
         row has not been laid out yet, try again next frame rather than
         giving up — a single early miss must not lose the callout. */
      if (!placeLowStock(btn)) {
        lowEl.hidden = true;
        if ((tries || 0) < 8) {
          requestAnimationFrame(function () { showLowStock(v, btn, (tries || 0) + 1); });
        }
        return;
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { lowEl.classList.add('is-on'); });
      });
      var hold = (parseFloat(lowEl.dataset.hold) || 4) * 1000;
      lowShowT = setTimeout(hideLowStock, hold);
    }

    /* First run only: hold until the buy row is actually in view, and until
       the display face has loaded — measuring in a fallback face would
       centre it on the wrong width and leave it off its size. */
    function primeLowStock(v, btn) {
      if (!lowEl || lowPrimed) return;
      lowPrimed = true;
      function go() {
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () { showLowStock(v, btn); });
        } else {
          showLowStock(v, btn);
        }
      }
      if (!('IntersectionObserver' in window)) { go(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          go();
        });
      }, { threshold: 0.6 });
      io.observe(lowRow);
    }

    /* A resize moves the size it is pointing at, so drop it rather than
       leave it pointing somewhere wrong. */
    if (lowEl) window.addEventListener('resize', hideLowStock);

    // Central place that reflects the chosen variant into price / stock / the
    // ADD button, and exposes its id so the inline BUY NOW handler can read it.
    function applySelected(v) {
      selected = v || null;
      root.dataset.kSelectedVariant = v ? v.id : '';
      if (v) priceEls.forEach(function (el) { el.textContent = formatMoney(v.price); });
      if (addBtn) {
        var ok = !!(v && v.available);
        addBtn.disabled = !ok;
        addBtn.textContent = ok ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
      }
      if (stockEl) {
        if (!v || !v.available) {
          stockEl.textContent = v ? stockEl.dataset.labelSoldout : '';
          stockEl.classList.remove('k-stock--low');
        } else if (v.inventory_quantity > 0 && v.inventory_quantity <= 5) {
          stockEl.textContent = v.inventory_quantity + ' ' + stockEl.dataset.labelLeft;
          stockEl.classList.add('k-stock--low');
        } else if (v.inventory_quantity > 5) {
          stockEl.textContent = v.inventory_quantity + ' ' + stockEl.dataset.labelStock;
          stockEl.classList.remove('k-stock--low');
        } else {
          stockEl.textContent = '';
        }
      }
    }

    if (optBtns.length) {
      // Multi-option (e.g. the jacket + jeans set): a value per option row,
      // resolved to the variant whose option1/option2/... all match.
      var chosen = {};
      function variantFor(sel) {
        return data.variants.find(function (vr) {
          return Object.keys(sel).every(function (o) { return String(vr['option' + o]) === String(sel[o]); });
        });
      }
      // A value is sold out (greyed + struck + unclickable, like a sold-out size
      // on a normal product) when no AVAILABLE variant carries that value together
      // with the currently-chosen value(s) of the other option(s). This also means
      // you can never end up on a sold-out combination.
      function updateAvailability() {
        optBtns.forEach(function (btn) {
          var o = btn.dataset.kOpt, v = btn.dataset.kOptval;
          var avail = data.variants.some(function (vr) {
            if (!vr.available || String(vr['option' + o]) !== String(v)) return false;
            return Object.keys(chosen).every(function (p) {
              return p === o || String(vr['option' + p]) === String(chosen[p]);
            });
          });
          btn.classList.toggle('is-disabled', !avail);
          btn.disabled = !avail;
        });
      }
      function syncSelected() {
        optBtns.forEach(function (btn) {
          btn.classList.toggle('is-selected', String(chosen[btn.dataset.kOpt]) === String(btn.dataset.kOptval));
        });
      }
      function refresh() {
        syncSelected();
        updateAvailability();
        applySelected(variantFor(chosen) || null);
      }
      optBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled || btn.classList.contains('is-disabled')) return;
          chosen[btn.dataset.kOpt] = btn.dataset.kOptval;
          refresh();
          showLowStock(variantFor(chosen) || null, btn);
        });
      });
      // preselect the first AVAILABLE combination so it starts on a buyable variant
      var firstAvail = data.variants.find(function (v) { return v.available; }) || data.variants[0];
      if (firstAvail) {
        optBtns.forEach(function (btn) { chosen[btn.dataset.kOpt] = String(firstAvail['option' + btn.dataset.kOpt]); });
      }
      refresh();
      primeLowStock(variantFor(chosen) || null, root.querySelector('.k-pdp__size.is-selected'));
    } else if (sizeBtns.length) {
      // Single-option: one button per variant.
      function pickSingle(btn, fromUser) {
        sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var v = data.variants.find(function (vr) { return String(vr.id) === btn.dataset.kSize; });
        applySelected(v);
        /* Picking a size is deliberate, so answer straight away; the initial
           selection nobody made waits for the row to be on screen. */
        if (fromUser) showLowStock(v, btn); else primeLowStock(v, btn);
      }
      sizeBtns.forEach(function (btn) { btn.addEventListener('click', function () { pickSingle(btn, true); }); });
      var first = Array.prototype.find.call(sizeBtns, function (b) { return !b.classList.contains('is-disabled'); });
      if (first) pickSingle(first);
      else if (sizeBtns.length) pickSingle(sizeBtns[0]);
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!selected) return;
        addBtn.textContent = '...';
        addToCart(selected.id, 1)
          .then(function () { addBtn.textContent = addBtn.dataset.labelAdd; })
          .catch(function () { addBtn.textContent = addBtn.dataset.labelSoldout; });
      });
    }
  });

  /* ---------------- Accordions ---------------- */
  document.querySelectorAll('.k-acc__item').forEach(function (item) {
    // Static panels (PAIR WITH) stay open and are not clickable.
    if (item.classList.contains('k-acc__item--static')) return;

    var head = item.querySelector('.k-acc__head');
    var body = item.querySelector('.k-acc__body');
    head.addEventListener('click', function () {
      var open = !item.classList.contains('is-open');

      // One panel open at a time: close every sibling in the same
      // accordion first. Scoped to the group so separate accordions on a
      // page don't close each other.
      var group = item.closest('.k-acc');
      if (group) {
        group.querySelectorAll('.k-acc__item.is-open:not(.k-acc__item--static)').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          var otherBody = other.querySelector('.k-acc__body');
          if (otherBody) otherBody.style.maxHeight = '0px';
        });
      }

      item.classList.toggle('is-open', open);
      // Generous max-height: content with late-loading images (size
      // charts) would otherwise get clipped at its pre-load height.
      body.style.maxHeight = open ? '4000px' : '0px';
    });
  });

  /* ---------------- Pair-with recommendations ---------------- */
  var pair = document.querySelector('[data-k-pair]');
  if (pair) {
    fetch('/recommendations/products.json?product_id=' + pair.dataset.kPair + '&limit=4')
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var products = res.products || [];
        if (!products.length) { pair.closest('.k-pair').style.display = 'none'; return; }
        pair.innerHTML = products.map(function (p) {
          var img2 = p.images && p.images[1] ? '<img class="k-card__img k-card__img--alt" src="' + p.images[1] + '" alt="" loading="lazy">' : '';
          return (
            '<a class="k-card" href="' + p.url + '">' +
              '<div class="k-card__media">' +
                '<img class="k-card__img k-card__img--main" src="' + (p.featured_image || '') + '" alt="' + p.title + '" loading="lazy">' +
                img2 +
              '</div>' +
              '<div class="k-card__meta">' +
                '<span class="k-card__title">' + p.title + '</span>' +
                '<span class="k-card__price">' + formatMoney(p.price) + '</span>' +
              '</div>' +
            '</a>'
          );
        }).join('');
      })
      .catch(function () { pair.closest('.k-pair').style.display = 'none'; });
  }

  /* ---------------- Reveal on scroll ---------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.k-reveal').forEach(function (el) { io.observe(el); });
  }

  /* Initial bag count */
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setBagCount(c.item_count); });
})();
